import React, { Suspense } from "react";
import {
  AppointmentProps,
  ButtonAppointmentProps,
  ButtonCardState,
  FormProps,
} from "./ButtonAppointment.types";
import {
  ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { ButtonAppointmentBox } from "./ButtonAppointment.style";
const AppointmentModal = React.lazy(() => import("./AppointmentModal/AppointmentModal"));

export default class ButtonAppointment extends Container<
  ButtonAppointmentProps,
  ButtonCardState
> {
  constructor(props: ButtonAppointmentProps) {
    super(props);

    const storedData = sessionStorage.getItem('personalData');
    const initialData = storedData ? JSON.parse(storedData) : {};

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
      isModalOpen: false,
      email: initialData.email || "",
      name: initialData.name || "",
      phone: initialData.phone || "",
      state: initialData.state || "",
      city: initialData.city || "",
      dateTime: "",
      storeSalesforce: "",
      storePhysical: "",
      address: "",
      manager: "",
      managerPhone: "",
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    this.checkHash();
    window.addEventListener("hashchange", this.checkHash);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.checkHash);
  }

  checkHash = () => {
    const anchorId = this.props.id;
    if (window.location.hash === `#${anchorId}`) {
      this.setState({ isModalOpen: true });
    }
  };

  handleFormSubmit = (formData: FormProps) => {
    this.setState({
      email: formData.email,
      name: formData.fullName,
      phone: formData.phone,
      state: formData.estado, 
      city: formData.cidade,
    });
    
    const appointmentData = {
      email: formData.email,
      name: formData.fullName,
      phone: formData.phone,
      estado: formData.estado,
      cidade: formData.cidade,
    };
    sessionStorage.setItem('personalData', JSON.stringify(appointmentData));
  };

  handleAppointmentSubmit = (appointmentData: AppointmentProps) => {
    this.setState({ storeSalesforce: appointmentData.storeSalesforce });
    this.setState({ storePhysical: appointmentData.storePhysical });
    this.setState({manager: appointmentData.manager});
    this.setState({managerPhone: appointmentData.managerPhone});
  };

  handleDateTimeSubmit = (value: string) => {
    this.setState({ dateTime: value });
  };

  handleAddressSubmit = (value: string) => {
    this.setState({ address: value });
  };

  handleButtonClick = () => {
    const storedData = sessionStorage.getItem('personalData');
    const initialData = storedData ? JSON.parse(storedData) : {};
  
    this.setState({
      email: initialData.email || "",
      name: initialData.name || "",
      phone: initialData.phone || "",
      state: initialData.estado || "", 
      city: initialData.cidade || "", 
      isModalOpen: true
    });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
    const currentUrl = window.location.href;
    const newUrl = currentUrl.split('#')[0];
    window.history.replaceState(null, '', newUrl);
  };

  render() {
    const {
      backgroundColor,
      label,
    } = this.props;
    const { isModalOpen } = this.state;

    return (
      <>
        <ButtonAppointmentBox
          id={this.props.id}
          className="buttoncard"
          $backgroundcolor={backgroundColor}
          onClick={this.handleButtonClick}
          aria-label={label}
        >
          {this.childComponents && (
            <>
              {this.childComponents.length > 0 && (
                <div className="buttoncard__icon">
                  {this.childComponents[0]}
                </div>
              )}

              {this.childComponents.length > 1 && (
                <div className="buttoncard__text">
                  {this.childComponents.slice(1).map((item, k) => (
                    <div key={k + 1}>{item}</div>
                  ))}
                </div>
              )}
            </>
          )}
        </ButtonAppointmentBox>
        {this.childComponents.length < 3 && this.placeholderComponent}

        {isModalOpen && (
          <Suspense fallback={null}>
            <AppointmentModal
              onClose={this.closeModal}
              onFormSubmit={this.handleFormSubmit}
              onDateTimeSubmit={this.handleDateTimeSubmit}
              onAddressSubmit={this.handleAddressSubmit}
              onAppointmentSubmit={this.handleAppointmentSubmit}
              email={this.state.email}
              city={this.state.city}
              state={this.state.state}
              dateTime={this.state.dateTime}
              name={this.state.name}
              address={this.state.address}
              storeSalesforce={this.state.storeSalesforce}
              storePhysical={this.state.storePhysical}
              manager={this.state.manager}
              managerPhone={this.state.managerPhone}
              phone={this.state.phone}
              {...this.props}
            />
          </Suspense>
        )}
      </>
    );
  }
}
